export const routesCDN = {
  imageCDN: '/image-cdn',
};
